import { newWebAction } from "../../../../../../common/factory/action.factory";
import { addNewVariable } from "../../../../../../common/factory/variable.factory";
import { ActionRenderOptions } from "../../../../../../common/constants/core/action.constants";
import { PaginationType } from "../../../../../../common/interfaces/flow/action/WebRequestAction";
import { createFlowPayload,createFlowInstance} from "../../../payload/generic.flow"
import {createPagination} from "../../../../../../integrations/flow/edit/action/tabs/behavioursTab/pagination/utils/paginationUtil"
import importMappingConfig from "./oktaImportMappingConfig.json"
import {getImportMappingJson} from "../../../../common/util/importmapping.filter"
import {paginationScript} from "./okta.pagination"
import {dig} from "./okta.dig"
import { createCondition } from "../../../../../../common/factory/condition.factory";
import { ConditionType } from "../../../../../../common/interfaces/flow/condition/ConditionType";

export const createOktaImportFlowPayload = (scheduleCron,importSourceName, assetSchema, currentData, workspaceId, importSourceId,importCredentialObject,oktaTokenObject) => {
    
    //get the okta config   
    const objectTypeNames = Object.keys(currentData.oktaConfig).map(key => currentData.oktaConfig[key].value);

    //init flow
    let flow = createFlowInstance(scheduleCron,
            "Jira Asset Import: Okta",
            "This integration imports Okta data into Jira Assets and place them in the Asset Schema: "+assetSchema.label+" in the Object Type(s): "+objectTypeNames+"\nThe Import Source is called "+importSourceName)
    

    //console.log(flow)
    //create custom get data, e.g fetch Get Okta Users
    let apis = [{ oktaObject: 'Okta Apps', url: "/api/v1/apps",type:"", selector:"apps" },
    { oktaObject: 'Okta Roles', url: "/api/v1/iam/roles",type:"", selector:"roles" },
    { oktaObject: 'Okta Policies', url: "/api/v1/policies?type=PASSWORD", type:"PASSWORD", selector:"policies"},
    { oktaObject: 'Okta Policies', url: "/api/v1/policies?type=IDP_DISCOVERY", type:"IDP_DISCOVERY", selector:"policies" },
    { oktaObject: 'Okta Policies', url: "/api/v1/policies?type=MFA_ENROLL", type:"MFA_ENROLL", selector:"policies"},
    { oktaObject: 'Okta Users', url: "/api/v1/users",type:"", selector:"users" }, 
    { oktaObject: 'Okta Groups', url: "/api/v1/groups",type:"", selector:"groups" },
    { oktaObject: 'Okta Types', url: "/api/v1/meta/types/user",type:"", selector:"userTypes"}
    ]
    //fiter out selected APIS
    Object.keys(currentData.oktaConfig).forEach((key, index) => {
        if (currentData?.oktaConfig[key].checked === false) {
            apis = apis.filter(item => item.oktaObject !== key);
        }   
    });
    //create import mapping based on selected options
    const importMapping = getImportMappingJson(assetSchema,currentData,"oktaConfig",importMappingConfig);

    const actionsObject = apis.map((api)=>{

        const act = newWebAction(flow, "Get "+api.oktaObject+" "+api.type, null, ActionRenderOptions[0].value);
        act.method = "GET"
        act.url = "{{{nextUrl}}}";
        act.credentialsReference = oktaTokenObject
        let pagination = createPagination(PaginationType.CUSTOM,"nextUrl",paginationScript(currentData.oktaBaseUrl+api.url,200))
        pagination.enabled = true
        act.pagination = pagination 

        //Dig deeper for getting more data
        const moreInfo = dig(flow,api,ActionRenderOptions[0].value,oktaTokenObject,act.id,importCredentialObject)

        //create custom submit data for how the data is submitted, note body needs to match the selector. e.g users
        const submitData = newWebAction(flow, "Submit "+api.oktaObject+" "+api.type, act.id, ActionRenderOptions[0].value);
        submitData.method = "POST"
        addNewVariable(submitData,"submitResultsUrl","$.links.submitResults")
        submitData.url = "{{submitResultsUrl}}"
        submitData.credentialsReference = importCredentialObject

        //handle users and groups
        if(api.url === "/api/v1/users" || api.url === "/api/v1/groups"){
            submitData.body = "{\n    \"data\":{\n        \""+api.selector+"\":{{{flowVarMerge payload _flow 'id' 'apps'}}}\n    }\n}"
        }else{
            submitData.body = "{\n    \"data\":{\n        \""+api.selector+"\":{{{toJSON payload}}}\n    }\n}"
        }

        const combinedCondition = createCondition(ConditionType.COMBINED_CONDITION)
        const httpCondition = createCondition(ConditionType.HTTP_STATUS_CODE_CONDITION, {value:"200"})
        combinedCondition.conditions.push(httpCondition)
        submitData.conditions = [combinedCondition]
        



        return {
            fetchAction: act,
            childActions: [submitData,...moreInfo]
        }
    })



    //console.log(importCredentialObject)
    const customImport = {
        importMappingConfig:JSON.stringify(importMapping, null, 2),
        customActionObjects: actionsObject
    }
    //console.log(customImport)
    return createFlowPayload(flow,
        workspaceId, 
        importSourceId,
        importCredentialObject,
        customImport)

}